// extracted by mini-css-extract-plugin
export default {"favorites__wrapper":"styles_favorites__wrapper__uJhmz","navigationCollapse":"styles_navigationCollapse__I6PPF"};